import { Box, Text, Image, Stack, Button } from "@chakra-ui/react";
import { truncate } from "./Util";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const NavLink = styled(Link)``;

const CardText = ({ 
  children, 
  size = "14px",
  color = "black", 
  weight = 400,
}) => {
    return (
      <Text
        color={color}
        fontSize={size}
        fontWeight={weight}
        whiteSpace={"pre-wrap"}
      >
        {children}
      </Text>
    )
};

const CardNews = ({
  screen,
  img,
  category,
  title,
  content,
  url,
  created,
}) => {
  const [width, setWidth] = useState<string>("440px");
  const [height, setHeight] = useState<string>("673px");
  const [fSize, setFSize] = useState<any>({
    title: "30px",
    content: "20px",
    category: "20px",
    sub: "18px",
  });

  useEffect(() => {
    if (screen === "mobile") {
      setWidth("295px");
      setHeight("477px");
      setFSize({
        title: "17px",
        content: "12px",
        category: "12px",
        sub: "10px",
      });
    } else if (screen === "tablet") {
      setWidth("295px");
      setHeight("477px");
      setFSize({
        title: "22px",
        content: "14px",
        category: "14px",
        sub: "12px",
      });
    } else {
      setWidth("440px");
      setHeight("673px");
      setFSize({
        title: "30px",
        content: "20px",
        category: "20px",
        sub: "18px",
      });
    }

  }, [screen]);

  return (
    <Stack borderRadius={10} w={"295px"} h={"477px"} border={"1px solid #7D7979"} margin={"30px 15px"}>
      <Image src={img} alt="" h={"40%"} borderRadius={"10 10 0 0"} />
      <Stack padding={"15px"} h={"60%"}>
        <CardText size={"14px"} weight={600}>{`_${category}`}</CardText>
        <CardText size={"22px"} weight={600}>{truncate(title, 16)}</CardText>
        <Box h={"40%"}>
          <CardText size={"14px"}>{truncate(content, 70)}</CardText>
        </Box>
        <NavLink to={url} target={"_blank"}>
          <Button w={"50%"} background={"transparent"} border={"1px solid #333333"} borderRadius={0} _hover={{ background: "transparent" }}>
            <CardText size={"12px"} color={"#333333"}>바로가기</CardText>
          </Button>
        </NavLink>
        <CardText size={"12px"} color={"#7D7979"}>{created}</CardText>
      </Stack>
    </Stack>
  )
};

export default CardNews;